import React from "react";
// core components
import { SectionBanner } from "organisms";
import { Background } from "atoms";
import { Badge, LegalContainer } from "molecules";
import { TEXTS, ICONS } from "../../constants";

import "./styles.scss";

export default class LandingPage extends React.Component {
  render() {
    return (
      <div className="legal">
        <Background />
        <SectionBanner title={TEXTS.LEGAL_TITLE} />
        <Badge icon={ICONS.CAUTION} description={TEXTS.LEGAL_DISCLAIMER} />
        <LegalContainer />
        <LegalContainer ES />
      </div>
    );
  }
}
